import { useAtom, useSetAtom } from "jotai";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";

import {
  accessTokenAtom,
  isAnonymousUserAtom,
  refreshTokenAtom,
  showsSessionExpiredModalAtom,
} from "@/utils/atoms";

/*
 * This hook handles the redirect to the partner portal after the user has logged in.
 * For partner app, we simply redirect to the cockpit if authenticated.
 */
export const usePartnerLoginRedirect: () => boolean = () => {
  const [accessToken] = useAtom(accessTokenAtom);
  const [refreshToken] = useAtom(refreshTokenAtom);
  const [isRedirecting, setIsRedirecting] = useState(false);
  const navigate = useNavigate();

  const [isAnonymousUser] = useAtom(isAnonymousUserAtom);
  const setShowSessionExpiredModal = useSetAtom(showsSessionExpiredModalAtom);

  useEffect(() => {
    if (accessToken && refreshToken && !isAnonymousUser) {
      setIsRedirecting(true);
      setShowSessionExpiredModal(undefined);
      navigate("/partner/cockpit", { replace: true });
    } else {
      setIsRedirecting(false);
    }
  }, [
    accessToken,
    isAnonymousUser,
    navigate,
    refreshToken,
    setShowSessionExpiredModal,
  ]);

  return isRedirecting;
};
